(function($)
{
    $.extend(true, orion, {
        api: {
            shoppinglist: {}
        }
    });

    var api = orion.api.shoppinglist,
        uri = '/api-shoppinglist';

    function createShoppingList(data)
    {
        var promise = $.ajax(uri, {
            cache: false,
            headers: {
                Accept: 'application/json'
            },
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(data),
            method: 'POST'
        });

        return promise;
    }

    function create(data, defaultShoppingListId)
    {
        var promise = $.ajax(uri + '/' + defaultShoppingListId + '/items', {
            cache: false,
            headers: {
                Accept: 'application/json'
            },
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(data),
            method: 'PUT'
        });

        return promise;
    }

    function deleteItems(data, defaultShoppingListId)
    {
        var promise = $.ajax(uri + '/' + defaultShoppingListId + '/items', {
            cache: false,
            headers: {
                Accept: 'application/json'
            },
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(data),
            method: 'DELETE'
        });

        return promise;
    }

    function del(data)
    {
        var promise = $.ajax(uri + '/' + data.productNumber, {
            cache: false,
            data: $.extend({}, data, {
                _method: 'DELETE'
            }),
            method: 'POST'
        });

        return promise;
    }

    function readAllItems(defaultShoppingListId)
    {
        var promise = $.ajax(uri + '/' + defaultShoppingListId + '/items/all', {
            method: 'GET'
        });

        return promise;
    }

    function readHeaderData(shoppingListId)
    {
        console.log('readHeaderData');
        var promise = $.ajax(uri + '/' + shoppingListId, {
            method: 'GET'
        });

        console.log(promise);
        return promise;
    }

    function readItems(shoppingListId, skip, take)
    {
        var promise = $.ajax(uri + '/' + shoppingListId + '/items', {
            method: 'GET',
            data: {
                skip: skip,
                take: take,
                draw: 0,
                order: {
                    0: {
                        field: 'productNumber',
                        dir: 'asc'
                    }
                }
            },
            headers: {
                Accept: 'application/json'
            }
        });

        return promise;
    }

    api.create = create;
    api.createShoppingList = createShoppingList;
    api.del = del;
    api.deleteItems = deleteItems;
    api.readItems = readItems;
    api.readAllItems = readAllItems;
    api.readHeaderData = readHeaderData;
})(jQuery);
